var _defs, _g, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownloadPayment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 31.249,
    viewBox: "0 0 30 31.249",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10486",
    "data-name": "Path 10486",
    d: "M0,0H22.944V29.841H0Z",
    fill: "#9f523c",
    opacity: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1163",
    "data-name": "Group 1163",
    transform: "translate(0 22.944) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_34",
    "data-name": "Mask Group 34",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10458",
    "data-name": "Path 10458",
    d: "M7.135,7.554a.856.856,0,0,0-.5.178L.318,12.623a.82.82,0,0,0,0,1.3l6.317,4.891a.857.857,0,0,0,1.148-.084.82.82,0,0,0,.225-.565V15.757h8.363a.852.852,0,0,0,.6-.242.823.823,0,0,0,.248-.584V11.612a.822.822,0,0,0-.248-.584.852.852,0,0,0-.6-.242H8.008V8.379a.822.822,0,0,0-.258-.594.854.854,0,0,0-.615-.232Z",
    transform: "translate(1.681 1.65)",
    fill: "#61703f"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_162",
    "data-name": "Rectangle 162",
    width: 30,
    height: 7,
    rx: 2,
    transform: "translate(0 24.249)",
    fill: "#61703f"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadPayment);
export default __webpack_public_path__ + "static/media/download-payment.f3f21a32864673a636c13f8462a6d60a.svg";
export { ForwardRef as ReactComponent };